import styled from 'styled-components'

import { IQuizColor } from 'src/api/quizzes/types'
import { fontWeight, color as themeColor } from 'src/styles'
import { fontSize } from 'src/styles/fonts'

interface IQuizProps {
  colors: IQuizColor
}
export const Wrap = styled.div<IQuizProps>`
  background: ${({ colors: { bgStart, bgEnd } }) =>
    `linear-gradient(45deg, ${bgStart}, ${bgEnd})`};
  border-radius: 1.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

export const Illustration = styled.img`
  max-width: 100%;
  height: 20.8rem;
  margin-top: 4rem;
  object-fit: cover;
`

export const Title = styled.h3<{ color: string }>`
  font-size: ${fontSize.LARGE_XXXL};
  font-weight: ${fontWeight.EXTRA};
  color: ${({ color }) => color};
  margin: 4rem 0;
  padding: 0 3rem;
  text-align: center;
`

export const CompletedLabel = styled.span`
  background-color: ${themeColor.DUSTY_ORANGE};
  border-radius: 0.6rem;
  font-size: ${fontSize.SMALL};
  font-weight: ${fontWeight.EXTRA};
  line-height: 2.4rem;
  color: ${themeColor.CLAY_BROWN};
  padding: 0 0.4rem;
  text-transform: uppercase;
  position: absolute;
  right: 1.8rem;
  top: 1.8rem;
`
